import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/pwa-fixes.css';
import { captureSignupAttribution } from './utils/signupAttribution';

// Origem do cadastro (utm/gclid/referrer), lida antes de qualquer redirecionamento
captureSignupAttribution();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker REMOVIDO.
//
// O Service Worker foi descontinuado por causar loops de recarregamento e servir
// versões antigas do bundle (cache-first). Não registramos mais nenhum SW.
//
// Aqui, em QUALQUER ambiente, desregistramos qualquer Service Worker que ainda
// esteja instalado de sessões/versões anteriores e limpamos todos os caches.
// O arquivo public/sw.js virou um "kill-switch" que também faz essa limpeza para
// quem ainda o tenha ativo — este bloco é uma camada extra de segurança.
if ('serviceWorker' in navigator) {
  try {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch(() => {});
  } catch (e) {
    // in-app browsers (Instagram, Facebook) podem lançar exceção — falha silenciosa
  }

  if (window.caches && caches.keys) {
    caches.keys()
      .then((cacheNames) => {
        cacheNames.forEach((cacheName) => caches.delete(cacheName));
      })
      .catch(() => {});
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
